import React, { useEffect } from 'react';
import { Dashboard as DashboardLayout } from 'layouts';
import { Grid2 } from '@mui/material';
import styles from './styles';
import { makeStyles } from '@mui/styles';

import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Clear, PriorityHigh, Warning } from '@mui/icons-material';
import { getEvents } from 'js/actions/systemAlertAction';
import Card from './components/Card';
import AlertTable from './components/AlertTable';
import { useState } from 'react';

const useStyles = makeStyles(styles);

export default function NotificationDashboard() {
  const classes = useStyles();
  const intl = useIntl();
  const dispatch = useDispatch();
  const { events } = useSelector((state) => state.systemAlert);
  const [levelOne, setLevelOne] = useState(0);
  const [levelTwo, setLevelTwo] = useState(0);
  const [levelThree, setLevelThree] = useState(0);
  const [dataEvents, setDataEvents] = useState([]);
  const { user } = useSelector((state) => state.user);

  useEffect(() => {
    if (user) {
      dispatch(getEvents(user?.personal_info?.id_user));
    }
  }, [user]);

  useEffect(() => {
    let leveOneCount;
    if (events) {
      leveOneCount = events.filter((lvl) => lvl.lvl === 1);
      setLevelOne(leveOneCount.length);
    }
    let leveTwoCount;
    if (events) {
      leveTwoCount = events.filter((lvl) => lvl.lvl === 2);
      setLevelTwo(leveTwoCount.length);
    }
    let leveThreeCount;
    if (events) {
      leveThreeCount = events.filter((lvl) => lvl.lvl === 3);
      setLevelThree(leveThreeCount.length);
    }
    let dataEvent;
    if (events) {
      dataEvent = events.map((event) => {
        return {
          id: event?._id,
          date: event?.timestamp.$date.$numberLong,
          description: event?.message,
          level: event?.lvl,
          location: event?.corporative_name,
          // ¡Aquí está el cambio! Usamos 'alarm_type' de tus datos.
          eventType: event?.alarm_type || 'Desconocido',
        };
      });
      setDataEvents(dataEvent);
    }
  }, [events]);

  const handleFilter = (level) => {
    if (level === 0) {
      setDataEvents(
        events.map((event) => ({
          id: event?._id,
          date: event?.timestamp.$date.$numberLong,
          description: event?.message,
          level: event?.lvl,
          location: event?.corporative_name,
          eventType: event?.alarm_type || 'Desconocido',
        }))
      );
      return;
    }
    // Filtramos los eventos por nivel
    const filteredEvents = events.filter((event) => event.lvl === level);
    setDataEvents(
      filteredEvents.map((event) => ({
        id: event?._id,
        date: event?.timestamp.$date.$numberLong,
        description: event?.message,
        level: event?.lvl,
        location: event?.corporative_name,
        eventType: event?.alarm_type || 'Desconocido',
      }))
    );
  };

  return (
    <DashboardLayout title="Control de Alertas">
      <div className={classes.root}>
        <Grid2 container={true} spacing={4}>
          <Grid2 size={{ lg: 3, md: 6, sm: 6, xs: 12 }}>
            <Card
              onClick={() => handleFilter(0)}
              title="Total de Alertas"
              icon={
                <PriorityHigh
                  sx={{
                    fontSize: '2rem',
                    color: 'white',
                    height: '2rem',
                    width: '2rem',
                  }}
                />
              }
              alert={levelOne + levelTwo + levelThree}
              bgColor="#4caf50"
            />
          </Grid2>
          <Grid2 size={{ lg: 3, md: 6, sm: 6, xs: 12 }}>
            <Card
              onClick={() => handleFilter(1)}
              title={intl.formatMessage({
                id: 'app.alerts.header.lowLevelIssues',
              })}
              icon={
                <PriorityHigh
                  sx={{
                    fontSize: '2rem',
                    color: 'white',
                    height: '2rem',
                    width: '2rem',
                  }}
                />
              }
              alert={levelOne}
              bgColor="#0086c0"
            />
          </Grid2>
          <Grid2 size={{ lg: 3, md: 6, sm: 6, xs: 12 }}>
            <Card
              onClick={() => handleFilter(2)}
              title={intl.formatMessage({
                id: 'app.alerts.header.mediumLevelIssues',
              })}
              icon={
                <Warning
                  sx={{
                    fontSize: '2rem',
                    color: 'white',
                    height: '2rem',
                    width: '2rem',
                  }}
                />
              }
              alert={levelTwo}
              bgColor="#fdab3d"
            />
          </Grid2>
          <Grid2 size={{ lg: 3, md: 6, sm: 6, xs: 12 }}>
            <Card
              onClick={() => handleFilter(3)}
              title={intl.formatMessage({
                id: 'app.alerts.header.highLevelIssues',
              })}
              icon={
                <Clear
                  sx={{
                    fontSize: '2rem',
                    color: 'white',
                    height: '2rem',
                    width: '2rem',
                  }}
                />
              }
              alert={levelThree}
              bgColor="#e2445c"
            />
          </Grid2>
          <Grid2 size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
            <AlertTable alerts={dataEvents} />
          </Grid2>
        </Grid2>
      </div>
    </DashboardLayout>
  );
}
